<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <panel-title icon="mdi-link-box-variant" :title="getParent.name" />
      </v-col>
      <v-col cols="12" lg="4" v-show="nav.icon" :key="key" v-for="(nav, key) in getNavigations">
        <v-card :to="`${getParentLink}/${nav.link}`">
          <v-card-text class="general-navigation--wrapper">
            <v-row no-gutters>
              <v-col cols="4">
                <div class="d-flex flex-column align-stretch">
                  <div class="general-navigation--icon-bg primary lighten-5 rounded pa-5">
                    <v-icon size="3.5rem">{{ nav.icon }}</v-icon>
                  </div>
                </div>
              </v-col>
              <v-col cols="8" class="d-flex justify-center align-center">
                <div class="general-navigation--text text-h4 font-weight-light primary--text">
                  {{ nav.name }}
                </div>
                <v-card-actions class="general-navigation--action">
                  <div class="pa-4">
                    <v-icon size="2rem">mdi-chevron-right</v-icon>
                  </div>
                </v-card-actions>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import PanelTitle from "@/components/PanelTitle.vue";

export default {
  name: "GeneralNavigation",
  components: { PanelTitle },

  computed: {
    // ...mapState({
    //   activeBreadcrumbs: state => state.activeBreadCrumbs
    // })
    ...mapGetters({
      getNavigation: "getNav"
    }),

    getParent() {
      return this.getNavigation(this.$route.meta.key);
    },

    getParentLink() {
      return this.getNavigation(this.$route.meta.key).link;
    },

    getNavigations() {
      return this.getNavigation(this.$route.meta.key).child;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~vuetify/src/styles/styles.sass";

.general-navigation--wrapper {
  border: 2px solid transparent;
  cursor: pointer;
}

.general-navigation--wrapper:hover {
  border-color: map-get($blue, "base");
}

.general-navigation--wrapper:hover .general-navigation--icon-bg {
  background-color: map-get($blue, "base") !important;
}

.general-navigation--wrapper:hover .general-navigation--text {
  color: map-get($blue, "base") !important;
}

.general-navigation--action {
  position: absolute;
  visibility: hidden;
  right: 0;
  transition: $bootable-transition;
}

.general-navigation--wrapper:hover .general-navigation--action {
  visibility: visible;
}

.general-navigation--wrapper:hover .general-navigation--action ::v-deep .v-icon {
  color: map-get($blue, "base") !important;
}
</style>